import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../redux/RefundNPromotionAction";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../slidebar/components/DarkMode";

export const MemberRefundHistoryDetail = ({
  refundid,
  setRefundid,
  setSwalProps,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const refundNPromotionState = useSelector(
    ({ refundNPromotion }) => refundNPromotion,
    shallowEqual
  );

  const handleClose = () => setRefundid(undefined);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  useEffect(() => {
    if (refundid) {
      const queryParams = {
        action: "refundhistorydetail",
        refundid,
      };
      dispatch(actions.memberRefundHistoryDetail(queryParams)).then((resp) => {
        resp = resp.data;
        if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
          setSwalProps({
            show: true,
            icon: "error",
            title: intl.formatMessage({ id: "error" }),
            text: resp.message,
          });
        }
      });

      return () => dispatch(actions.clearMemberRefundHistoryDetail());
    }
  }, [refundid]);

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        show={!!refundid}
        onHide={handleClose}
        centered
        data-bs-theme={mode}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "memberRefundHistoryDetail",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="member-div d-flex"
            style={{
              margin: "10px auto",
            }}
          >
            <div className="member-container">
              <div className="table-responsive">
                <table className="member-table">
                  <thead className="member-header1">
                    <tr className="member-row1">
                      <th className="member-cell hide-on-mobile">
                        {intl.formatMessage({ id: "no" })}
                      </th>
                      <th className="member-cell text-start text-nowrap">
                        {intl.formatMessage({ id: "username" })}
                      </th>
                      <th className="member-cell text-start text-nowrap">
                        {intl.formatMessage({ id: "refundType" })}
                      </th>
                      <th className="member-cell text-nowrap text-end">
                        {intl.formatMessage({ id: "refundNumber" })}
                      </th>
                      <th className="member-cell text-nowrap text-end">
                        {intl.formatMessage({ id: "regardingBalance" })}
                      </th>
                      <th className="member-cell text-nowrap text-start">
                        {intl.formatMessage({ id: "directionBaseOn" })}
                      </th>
                      <th className="member-cell text-nowrap text-end">
                        {intl.formatMessage({ id: "refundBalance" })}
                      </th>
                      <th className="member-cell text-nowrap text-start">
                        {intl.formatMessage({ id: "gameType" })}
                      </th>
                      <th className="member-cell text-nowrap text-start">
                        {intl.formatMessage({ id: "isEdited" })}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="member-body">
                    {refundNPromotionState.memberRefundHistoryDetail
                      ?.refundHistoryDetails &&
                    refundNPromotionState.memberRefundHistoryDetail
                      .refundHistoryDetails.length > 0 ? (
                      refundNPromotionState.memberRefundHistoryDetail.refundHistoryDetails.map(
                        (report, index) => (
                          <tr key={index} className="member-row1">
                            <td className="member-cell hide-on-mobile">
                              {index + 1}
                            </td>
                            <td className="member-cell text-start">
                              {report.username}
                            </td>
                            <td className="member-cell text-start">
                              {report.refundtype}
                            </td>
                            <td className="member-cell text-end">
                              {report.refundnumber}
                            </td>
                            <td className="member-cell text-end">
                              {report.regardingbalance}
                            </td>
                            <td className="member-cell">
                              {report.directionbaseon}
                            </td>
                            <td className="member-cell text-end">
                              {report.refundbalance}
                            </td>
                            <td className="member-cell">{report.gametype}</td>
                            <td className="member-cell">{report.isedited}</td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan="9">
                          <div className="no-record-wrapper oRecordDiv">
                            <i className="bi bi-search fs-1 mb-3" />
                            <div className="text-font2">
                              {intl.formatMessage({ id: "noRecordFound" })}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
